const GRANT_ACCESS_PAGE = (state) =>
  `https://accounts.zoho.com/oauth/v2/auth?scope=PhoneBridge.call.log,PhoneBridge.zohoone.search&client_id=1000.7RHNJB70UHBQX28ZAWTREGK4NLKVRQ&redirect_uri=https://extension.jasconnect.com/app/&state=${state}&response_type=code&access_type=offline`;

const SERVER_BASE_URL =
  process.env.REACT_APP_SERVER_BASE_URL ||
  "https://jasserver-10102727557.development.catalystappsail.com/jas/api";

export { GRANT_ACCESS_PAGE, SERVER_BASE_URL };
